import { render, staticRenderFns } from "./PublicStartupProfile.vue?vue&type=template&id=d325add4&"
import script from "./PublicStartupProfile.vue?vue&type=script&lang=js&"
export * from "./PublicStartupProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports